<a href="/">
    <img
        src="assets/{{ logoFileName }}"
        alt="{{ 'project_name' | translate }}"
    />
</a>
